import { memo, useCallback } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { FPS_24 } from '@/App/remotion/constants';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import useTranscriptPage from '@/Pages/TranscriptPage/useTranscriptPage';
import { getPlayerConfigIntro } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/utils/playerConfigGetters';

const AddChapter = () => {
  const { currentTime } = useRemotionPlayerCurrentTime();
  const { clipData } = useClipsContext();
  const intro = getPlayerConfigIntro(clipData.asset_metadata.player_config);
  const deleteRanges = clipData.asset_metadata.deletes || {};
  const introEndTime = (intro?.toFrame ?? 0) / FPS_24;
  const chapterStartTime = currentTime - ((intro?.toFrame ?? 0) - (intro?.fromFrame ?? 0)) / FPS_24;
  const { createNewChapter } = useTranscriptPage();

  const isDisabled = introEndTime > currentTime;

  const addChapterHandle = useCallback(() => {
    const deleteTime = Object.entries(deleteRanges)
      .sort((itemA, itemB) => itemA[1].bounds[0] - itemB[1].bounds[0])
      .reduce((acc, [_, range]) => {
        if (range.bounds[0] <= chapterStartTime + acc) {
          return acc + (range.bounds[1] - range.bounds[0]);
        }
        return acc;
      }, 0);
    createNewChapter('New Chapter', chapterStartTime + deleteTime);
  }, [chapterStartTime, createNewChapter, deleteRanges]);

  return (
    <PlayerTimelineButton
      tooltipTitle="Add Chapter "
      buttonId="new-timeline-add-chapter-button"
      onClick={addChapterHandle}
      iconName="IconMenu4"
      isDisabled={isDisabled}
    />
  );
};

export default memo(AddChapter);
